import { Either, left, right } from "fp-ts/lib/Either";
import ShiftEntity from "../../../../domain/entities/ShiftEntity";
import ErrorEntity, { ErrorEntityFromError } from "../../../../domain/entities/ErrorEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import ShiftDto from "../../../dto/ShiftDto";

const UpdateShiftApiImpl = async (shift: ShiftEntity): Promise<Either<ErrorEntity, ShiftEntity>> => {
    try {
        const relativeUrl = `/shift/${shift.id}`;
        const body = ShiftDto.toJson(shift);
        const response = await di.get<HostApi>(HostApiName).put(relativeUrl, body, {
            contentType: "application/json",
        });

        const parsed: ShiftEntity = ShiftDto.fromJSON(response.data || response);
        return right(parsed);
    } catch (error) {
        return left(ErrorEntityFromError(error));
    }
}

export default UpdateShiftApiImpl;